import { useEffect, useRef } from 'react';

export const useTextareaEffects = (value: string, autoFocus?: boolean, recalculateOnOpen?: boolean) => {
  const ref = useRef<HTMLTextAreaElement | null>(null);

  const resize = () => {
    const el = ref.current;
    if (!el) return;
    el.style.height = 'auto'; // reset
    el.style.height = `${el.scrollHeight}px`;
  };

  useEffect(() => {
    resize();
  }, [value]);

  useEffect(() => {
    if (!recalculateOnOpen) return;
    requestAnimationFrame(() => {
      resize();
    });
  }, [recalculateOnOpen]);

  useEffect(() => {
    if (autoFocus && ref.current) {
      ref.current.focus();
      const length = ref.current.value.length;
      ref.current.setSelectionRange(length, length);
    }
  }, [autoFocus]);

  return ref;
};
